import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react'
import '../../css/common.css';
import { dateFormat, isBase64Encoded } from '../../common';

function UserDeviceForm(props) {
    const scroll = 'paper';

    const checkType = (type) => {
		if(type === 0) {
			return "안드로이드";
		} else if (type === 1) {
			return "IOS";
		} else {
			return "";
		}
	}

    return (
      <Dialog
        open={props.deviceDataOpen}
        onClose={props.deviceDataClose}
        scroll={scroll}
        fullWidth
        maxWidth="lg"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title" sx={{ fontWeight: 600 }}>
          사용자 단말 세부 정보
        </DialogTitle>
        <DialogContent
          dividers={scroll === "paper"}
          style={{ height: "500px" }}
        >
          <p style={{ marginBottom: "10px", fontWeight: "bold" }}>
            사용자 정보
          </p>
          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead
                sx={{
                  "& th": {
                    color: "rgb(255, 255, 255)",
                    backgroundColor: "rgb(45, 55, 72)",
                  },
                }}
              >
                <TableRow>
                  <TableCell align="center">이메일</TableCell>
                  <TableCell align="center">닉네임</TableCell>
                  <TableCell align="center">OS 종류</TableCell>
                  <TableCell align="center">OS 버전</TableCell>
                  <TableCell align="center">App 버전</TableCell>
                  <TableCell align="center">가입일자</TableCell>
                  <TableCell align="center">SNS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.userData ? (
                  props.userData.map((user) => {
                    return (
                      <TableRow key={user.id}>
                        <TableCell align="center">{user.id}</TableCell>
                        <TableCell align="center">{user.name}</TableCell>
                        <TableCell align="center">
                          {checkType(user.ostype)}
                        </TableCell>
                        <TableCell align="center">{user.osver}</TableCell>
                        <TableCell align="center">{user.appver}</TableCell>
                        {/* <TableCell align="center">{user.created.split('T')[0]}</TableCell> */}
                        <TableCell align="center">
                          {dateFormat(new Date(user.created))}
                        </TableCell>
                        <TableCell align="center">{user.snstype}</TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <p
            style={{
              marginTop: "40px",
              marginBottom: "10px",
              fontWeight: "bold",
            }}
          >
            단말 정보
          </p>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead
                sx={{
                  "& th": {
                    color: "rgb(255, 255, 255)",
                    backgroundColor: "rgb(45, 55, 72)",
                  },
                }}
              >
                <TableRow>
                  <TableCell align="center">단말아이디</TableCell>
                  <TableCell align="center">단말명</TableCell>
                  <TableCell align="center">모델명</TableCell>
                  <TableCell align="center">기기상태</TableCell>
                  <TableCell align="center">F/W버전</TableCell>
                  <TableCell align="center">
                    등록일자
                  </TableCell>
                  <TableCell align="center">통신수단</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.deviceData ? (
                  props.deviceData.map((device) => {
                    return (
                      <TableRow key={device[0].id}>
                        <TableCell align="center">
                          {isBase64Encoded(device[0].id)
                            ? window.atob(device[0].id)
                            : device[0].id}
                        </TableCell>
                        <TableCell align="center">{device[0].name}</TableCell>
                        <TableCell align="center">{device[0].model}</TableCell>
                        <TableCell align="center">
                          {device[0].state === 0 ? "OFF" : "ON"}
                        </TableCell>
                        <TableCell align="center">{device[0].fwver}</TableCell>
                        <TableCell align="center">
                          {dateFormat(new Date(device[0].created))}
                        </TableCell>
                        {/* <TableCell align="center">{device[0].created.split('T')[0]}</TableCell> */}
                        <TableCell align="center">
                          {device[0].comm === 1 ? "WIFI" : "BT"}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.deviceDataClose}>닫기</Button>
        </DialogActions>
      </Dialog>
    );
}

export default UserDeviceForm